export function calculateCreditByPayment(payment, rate, term) {
    if (rate <= 0 || term <= 0 || payment <= 0) {
        throw new Error("Ставка, срок и платеж должны быть положительными числами");
    }
    const monthlyRate = rate / 12;
    const credit = (payment * (1 - Math.pow(1 + monthlyRate, -term))) / monthlyRate;
    return credit;
}
